import { isEmpty } from 'lodash';

import router from '@/router';
import store from '@/store';

import ctt from '@/utils/const';

import { login } from '@/api/auth';
import {
  getToken,
  backToLogin,
  isLocal,
  setSessionItem,
  normalizeWindowName,
  awaitTo
} from '@/utils/utils';

const whiteList = ['/login'];
const errPages = ['Page404', 'Page500'];

let errCount = 0;

function getFirstRealdataParams() {
  const device = store.state.socket.devicesSourseMap?.[0];
  return device ? { sn: device.sn, deviceType: device.deviceType } : {};
}

async function handleTokenRoute(to, from, next) {
  const reqState = await store.dispatch('admin/initBasicData');

  if (!reqState) {
    if (errCount++ >= 1) return backToLogin();
    return next({ path: '/500', replace: true, params: { loading: false } });
  }
  errCount = 0;

  if (to.path === '/login') {
    return next({ path: '/' });
  }

  const { authMenu, addRoutes } = store.state.admin;

  if (authMenu && isEmpty(authMenu)) {
    const [authMenuErr, acsRoutes] = await awaitTo(store.dispatch('admin/getAuthMenu'));

    if (authMenuErr) {
      console.error(authMenuErr);
      return next({ ...to, replace: true });
    }

    if (acsRoutes.length > 0) {
      router.addRoutes(acsRoutes);
      await Promise.all([
        store.dispatch('mqtt/initMqtt'),
        store.dispatch('device/initDeviceTypeInfo')
      ]);

      if (from.path === '/login' || to.fullPath === '/') {
        return next({
          path: acsRoutes[0].path !== '*' ? acsRoutes[0].path : '/error/404',
          replace: true
        });
      }
    }

    return next({ ...to, replace: true });
  }

  if (isLocal()) {
    if (to.path === '/devices/monitor') {
      if (to.redirectedFrom?.includes('realdata')) {
        return next();
      }
      return next({ name: 'Realdata', params: getFirstRealdataParams() });
    }
    return next();
  }

  if (to.matched.length === 0) {
    return next({ name: 'Page404' });
  }
  if (to.fullPath === '/' && addRoutes?.length) {
    return next(addRoutes[0].path !== '*' ? addRoutes[0].path : undefined);
  }
  next();
}

router.beforeEach(async (to, from, next) => {
  normalizeWindowName();

  if (errPages.includes(to.name)) return next();

  const token = getToken();

  if (token) {
    return handleTokenRoute(to, from, next);
  }

  if (isLocal()) {
    try {
      const res = await login();
      setSessionItem(ctt.ADMIN_TOKEN, res.data);
      store.dispatch('admin/getUserInfo');
      await store.dispatch('admin/getDeviceModel');
      next({ name: 'Realdata', params: getFirstRealdataParams() });
    } catch (err) {
      console.error(err);
      backToLogin();
    }
    return;
  }

  if (whiteList.includes(to.path)) {
    next();
  } else {
    backToLogin();
  }
});

router.onError(error => {
  const pattern = /Loading chunk (\d+) failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    router.replace(router.history.pending.fullPath);
  }
});
